var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { ref: "wrapper" }, [
    !_vm.successOpen
      ? _c(
          "form",
          {
            ref: "form",
            attrs: {
              id: "form-ozn__form",
              method: "post",
              action: "",
              autocomplete: "off",
            },
            on: { submit: _vm.submit },
          },
          [
            _c("h2", [
              _vm.steps > 1
                ? _c("small", [
                    _vm._v(
                      "Krok " + _vm._s(_vm.step) + " / " + _vm._s(_vm.steps)
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.steps > 1 ? _c("br") : _vm._e(),
              _vm._v(" "),
              !_vm.form.title
                ? _c("span", [_vm._v("Pomocniczy formularz zgłoszeniowy")])
                : _vm._e(),
              _vm._v(" "),
              _vm.form.title
                ? _c("span", [_vm._v(_vm._s(_vm.form.title))])
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c("p", [_vm._v("*) Pole wymagane")]),
            _vm._v(" "),
            _c("h3", [_vm._v("Informacje o podróży")]),
            _vm._v(" "),
            _c(
              "ic-form-row-horizontal",
              {
                attrs: {
                  new_id: "type",
                  aria: "Pole jest wymagane",
                  label: "Podróż odbywam",
                  labelWidth: 4,
                  controlWidth: 6,
                  error: _vm.hasError("form.type"),
                  required: _vm.isRequired("form.type"),
                },
              },
              [
                _c("ic-select", {
                  attrs: {
                    id: "type",
                    values: _vm.formTypes,
                    v: _vm.$v.form.type,
                    searchable: true,
                    allowEmpty: false,
                    placeholder: "... (wybierz jedną z dwóch opcji)",
                  },
                  model: {
                    value: _vm.form.type,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "type", $$v)
                    },
                    expression: "form.type",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _vm.form.type == "group"
              ? _c(
                  "ic-form-row-horizontal",
                  {
                    attrs: {
                      new_id: "bsoNo",
                      aria: "Pole jest wymagane",
                      label: "Nr wniosku",
                      labelWidth: 4,
                      controlWidth: 6,
                      error: _vm.hasError("form.bsoNo"),
                      required: _vm.isRequired("form.bsoNo"),
                    },
                  },
                  [
                    _c("ic-input", {
                      attrs: { id: "bsoNo", v: _vm.$v.form.bsoNo },
                      model: {
                        value: _vm.form.bsoNo,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "bsoNo", $$v)
                        },
                        expression: "form.bsoNo",
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.requireBSO
              ? _c(
                  "div",
                  [
                    _c(
                      "ic-form-row-horizontal",
                      {
                        attrs: {
                          new_id: "participants",
                          aria: "Pole jest wymagane",
                          label: "Towarzyszami podróży są",
                          labelWidth: 4,
                          controlWidth: 6,
                          error: _vm.hasError("form.participants"),
                          required: _vm.isRequired("form.participants"),
                        },
                      },
                      [
                        _c("ic-checkbox-group", {
                          attrs: {
                            id: "participants",
                            options: _vm.participantTypes,
                            v: _vm.$v.form.participants,
                          },
                          on: { input: _vm.onParticipantsSelected },
                          model: {
                            value: _vm.form.participants,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "participants", $$v)
                            },
                            expression: "form.participants",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.hasParticipants
                      ? _c(
                          "ic-form-row-horizontal",
                          {
                            attrs: {
                              new_id: "persons",
                              aria: "Pole jest wymagane",
                              label: "Liczba osób towarzyszących",
                              labelWidth: 4,
                              controlWidth: 6,
                              error: _vm.hasError("form.persons"),
                              required: _vm.isRequired("form.persons"),
                            },
                          },
                          [
                            _c("ic-input", {
                              attrs: { id: "persons", type: "number" },
                              model: {
                                value: _vm.form.persons,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "persons", $$v)
                                },
                                expression: "form.persons",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("h3", [_vm._v("Forma kontaktu")]),
                    _vm._v(" "),
                    _c(
                      "ic-form-row-horizontal",
                      {
                        attrs: {
                          new_id: "reply_via",
                          aria: "Pole jest wymagane",
                          label: "Forma odpowiedzi",
                          labelWidth: 4,
                          controlWidth: 6,
                          error: _vm.hasError("form.reply_via"),
                          required: _vm.isRequired("form.reply_via"),
                        },
                      },
                      [
                        _c("ic-select-system", {
                          attrs: {
                            id: "reply_via",
                            values: _vm.replyTypes,
                            allowEmpty: false,
                            v: _vm.$v.form.reply_via,
                            placeholder: "... (wybierz jedną z dwóch opcji)",
                          },
                          model: {
                            value: _vm.form.reply_via,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "reply_via", $$v)
                            },
                            expression: "form.reply_via",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.form.reply_via
                      ? _c(
                          "div",
                          [
                            _vm.form.reply_via === "email"
                              ? _c(
                                  "ic-form-row-horizontal",
                                  {
                                    attrs: {
                                      new_id: "email",
                                      aria: "Pole jest wymagane",
                                      label: "E-mail",
                                      labelWidth: 4,
                                      controlWidth: 6,
                                      error: _vm.hasError("form.email"),
                                      required: _vm.isRequired("form.email"),
                                    },
                                  },
                                  [
                                    _c("ic-input", {
                                      attrs: {
                                        id: "email",
                                        v: _vm.$v.form.email,
                                      },
                                      on: { keydown: _vm.preventPaste },
                                      model: {
                                        value: _vm.form.email,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.form, "email", $$v)
                                        },
                                        expression: "form.email",
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.form.reply_via === "email"
                              ? _c(
                                  "ic-form-row-horizontal",
                                  {
                                    attrs: {
                                      new_id: "email_confirm",
                                      aria: "Pole jest wymagane",
                                      label: "Potwierdzenie e-mail",
                                      labelWidth: 4,
                                      controlWidth: 6,
                                      error: _vm.hasError("form.email_confirm"),
                                      required:
                                        _vm.isRequired("form.email_confirm"),
                                    },
                                  },
                                  [
                                    _c("ic-input", {
                                      attrs: {
                                        id: "email_confirm",
                                        v: _vm.$v.form.email_confirm,
                                      },
                                      on: { keydown: _vm.preventPaste },
                                      model: {
                                        value: _vm.form.email_confirm,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "email_confirm",
                                            $$v
                                          )
                                        },
                                        expression: "form.email_confirm",
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "ic-form-row-horizontal",
                      {
                        attrs: {
                          new_id: "phone",
                          aria: "Pole jest wymagane",
                          label: "Telefon kontaktowy",
                          labelWidth: 4,
                          controlWidth: 6,
                          error: _vm.hasError("form.phone"),
                          required: _vm.isRequired("form.phone"),
                        },
                      },
                      [
                        _c("ic-input-phone", {
                          attrs: {
                            id: "phone",
                            v: _vm.$v.form.phone,
                            maxlength: "0",
                          },
                          model: {
                            value: _vm.form.phone,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "phone", $$v)
                            },
                            expression: "form.phone",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("h3", [_vm._v("Informacje dotyczące podróży")]),
                    _vm._v(" "),
                    _c("ic-form-ozn-connection", {
                      attrs: {
                        v: _vm.$v,
                        hasError: _vm.hasError,
                        isRequired: _vm.isRequired,
                      },
                      model: {
                        value: _vm.form.connections,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "connections", $$v)
                        },
                        expression: "form.connections",
                      },
                    }),
                    _vm._v(" "),
                    _c("h3", { staticStyle: { "font-size": "28px" } }, [
                      _vm._v(
                        "Informacje dotyczące niepełnosprawności lub ograniczeń w poruszaniu się"
                      ),
                    ]),
                    _vm._v(" "),
                    _c("ic-form-ozn-disability", {
                      attrs: {
                        participants: _vm.form.participants,
                        v: _vm.$v,
                        hasError: _vm.hasError,
                        isRequired: _vm.isRequired,
                      },
                      on: {
                        "update:persons": function ($event) {
                          _vm.form.persons = $event
                        },
                        "update:disabled_persons": function ($event) {
                          _vm.form.disabled_persons = $event
                        },
                      },
                      model: {
                        value: _vm.form.disabilities,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "disabilities", $$v)
                        },
                        expression: "form.disabilities",
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "mtm" },
                      [
                        _c(
                          "ic-form-row-horizontal2",
                          {
                            attrs: {
                              new_id: "disabled_persons",
                              label: "Liczba osób potrzebujących pomocy",
                              labelWidth: 5,
                              controlWidth: 2,
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "form-control form-control-static",
                                attrs: { id: "disabled_persons" },
                              },
                              [_vm._v(_vm._s(_vm.disabled_persons))]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "ic-form-row-horizontal2",
                          {
                            attrs: {
                              new_id: "total_persons",
                              label: "Łączna liczba osób",
                              labelWidth: 5,
                              controlWidth: 2,
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "form-control form-control-static",
                                attrs: { id: "total_persons" },
                              },
                              [_vm._v(_vm._s(_vm.total_persons))]
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("h3", [_vm._v("Zakres pomocy")]),
                    _vm._v(" "),
                    _c("ic-form-ozn-assistance", {
                      attrs: {
                        v: _vm.$v,
                        hasError: _vm.hasError,
                        isRequired: _vm.isRequired,
                      },
                      model: {
                        value: _vm.form.assistance,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "assistance", $$v)
                        },
                        expression: "form.assistance",
                      },
                    }),
                    _vm._v(" "),
                    _c("h3", [_vm._v("Informacje dodatkowe")]),
                    _vm._v(" "),
                    _c(
                      "ic-form-row-horizontal2",
                      {
                        attrs: {
                          new_id: "remarks",
                          label: "Uwagi",
                          labelWidth: 4,
                          controlWidth: 8,
                          aaaerror: "hasError('form.remarks')",
                        },
                      },
                      [
                        _c("ic-textarea", {
                          attrs: { id: "remarks" },
                          model: {
                            value: _vm.form.remarks,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "remarks", $$v)
                            },
                            expression: "form.remarks",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("hr"),
                    _vm._v(" "),
                    _vm._m(0),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-primary",
                            attrs: {
                              disabled: _vm.submitting,
                              "vvv-if": "!hasErrors()",
                            },
                          },
                          [
                            _vm.submitting
                              ? _c("span", [_vm._v("Proszę czekać")])
                              : _vm._e(),
                            _vm._v(" "),
                            !_vm.submitting
                              ? _c("span", [_vm._v("Wyślij")])
                              : _vm._e(),
                          ]
                        ),
                        _vm._v(" "),
                        _c("vue-loading", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.submitting,
                              expression: "submitting",
                            },
                          ],
                          attrs: {
                            type: "spin",
                            color: "#0071BC",
                            size: { width: "50px", height: "50px" },
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm._m(1),
    _vm._v(" "),
    _c("div", { attrs: { "aria-live": "assertive" } }, [
      _c(
        "div",
        {
          staticClass: "modal fade",
          attrs: {
            id: "tyModal",
            tabindex: "-1",
            "aria-labelledby": "thankYouModalLabel",
            "aria-hidden": "true",
            "data-bs-backdrop": "static",
            "data-bs-keyboard": "false",
          },
        },
        [
          _c("div", { staticClass: "modal-dialog" }, [
            _c("div", { staticClass: "modal-content" }, [
              _c("div", { staticClass: "modal-body" }, [
                _vm.step == _vm.steps
                  ? _c("div", [
                      _vm.steps == 1
                        ? _c("div", [
                            _c("h3", { staticClass: "text-center" }, [
                              _vm._v("Dziękujemy za zgłoszenie."),
                            ]),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(
                                "\n            Zostało ono przekazane do odpowiedniej jednostki merytorycznej w celu rozpatrzenia. Zgłoszenie zostało zarejestrowane pod numerem\n            "
                              ),
                              _vm.forms.length
                                ? _c("strong", [
                                    _vm._v(
                                      "#" + _vm._s(_vm.forms[0].form_number)
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(
                                " , podczas kontaktu z nami prosimy powołać się na ten numer.\n            "
                              ),
                              _c("br"),
                            ]),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.steps > 1
                        ? _c("div", [
                            _c("h3", { staticClass: "text-center" }, [
                              _vm._v("Dziękujemy za zgłoszenia."),
                            ]),
                            _vm._v(" "),
                            _c(
                              "p",
                              [
                                _vm._v(
                                  "\n            Zostały one przekazane do odpowiedniej jednostki merytorycznej w celu rozpatrzenia. Zgłoszenia zostały zarejestrowane pod numerami\n            \n            "
                                ),
                                _vm._l(_vm.forms, function (form, idx) {
                                  return _c("span", { key: idx }, [
                                    _c("strong", [
                                      idx > 0
                                        ? _c("i", [_vm._v(",")])
                                        : _vm._e(),
                                      _vm._v(
                                        "\n                #" +
                                          _vm._s(form.form_number) +
                                          "\n              "
                                      ),
                                    ]),
                                  ])
                                }),
                                _vm._v(
                                  ", podczas kontaktu z nami prosimy powołać się na te numery.\n          "
                                ),
                              ],
                              2
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._m(2),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.step < _vm.steps
                  ? _c(
                      "div",
                      {
                        staticClass: "text-center",
                        attrs: { "aria-live": "assertive" },
                      },
                      [
                        _c("h3", [_vm._v("Formularz został zapisany.")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v("Proszę przejść do następnego kroku..."),
                        ]),
                      ]
                    )
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "modal-footer" }, [
                _vm.step == _vm.steps
                  ? _c("div", [
                      _vm.forms[0] && _vm.steps == 1
                        ? _c(
                            "a",
                            {
                              staticClass: "btn btn-primary btn-sm pull-left",
                              attrs: {
                                type: "button",
                                href: _vm.forms[0].pdfUrl,
                                target: "_blank",
                              },
                            },
                            [_vm._v("Pobierz PDF")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.forms[0] && _vm.steps > 1
                        ? _c(
                            "a",
                            {
                              staticClass: "btn btn-primary btn-sm pull-left",
                              attrs: {
                                type: "button",
                                href: _vm.forms[0].pdfUrl,
                                target: "_blank",
                              },
                            },
                            [_vm._v('Pobierz PDF "tam"')]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.forms[1] && _vm.steps > 1
                        ? _c(
                            "a",
                            {
                              staticClass: "btn btn-primary btn-sm pull-left",
                              attrs: {
                                type: "button",
                                href: _vm.forms[1].pdfUrl,
                                target: "_blank",
                              },
                            },
                            [_vm._v('Pobierz PDF "z powrotem"')]
                          )
                        : _vm._e(),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.step < _vm.steps
                  ? _c(
                      "a",
                      {
                        staticClass: "btn btn-primary pull-right btn-sm",
                        attrs: {
                          type: "button",
                          href: _vm.pdfUrl,
                          target: "_blank",
                        },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.nextStep.apply(null, arguments)
                          },
                        },
                      },
                      [_vm._v("Następny krok")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.step == _vm.steps
                  ? _c(
                      "a",
                      {
                        staticClass: "btn btn-primary pull-right btn-sm",
                        attrs: {
                          type: "button",
                          href: _vm.pdfUrl,
                          target: "_blank",
                        },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.finish.apply(null, arguments)
                          },
                        },
                      },
                      [_vm._v("Zamknij")]
                    )
                  : _vm._e(),
              ]),
            ]),
          ]),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "form-group" }, [
      _c("p", [
        _vm._v(
          "Po zatwierdzeniu zgłoszenia przyciskiem „Wyślij”, zostanie ono przekazane do rozpatrzenia oraz będzie dostępna opcja zapisania zgłoszenia w pliku PDF na urządzeniu."
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _c("small", [
        _vm._v("\n        Tę stronę chroni rozwiązanie reCAPTCHA. Obowiązuje "),
        _c(
          "a",
          {
            attrs: {
              href: "https://policies.google.com/privacy",
              target: "_blank",
            },
          },
          [_vm._v("Polityka Prywatności")]
        ),
        _vm._v(" \n        oraz "),
        _c(
          "a",
          {
            attrs: {
              href: "https://policies.google.com/terms",
              target: "_blank",
            },
          },
          [_vm._v("Regulamin")]
        ),
        _vm._v(" Google. \n      "),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _vm._v(
        "\n          Uprzejmie informujemy, że wysłanie zgłoszenia nie jest równoznaczne z decyzją o zrealizowaniu pomocy.\n          "
      ),
      _c("br"),
      _vm._v("Prosimy czekać na odpowiedź ze strony Przewoźnika.\n        "),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }